(() => {
  const svg = `
    <svg width="20" height="20" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
      <path d="M640 768h512v-192q0-106-75-181t-181-75-181 75-75 181v192zm832 96v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h32v-192q0-184 132-316t316-132 316 132 132 316v192h32q40 0 68 28t28 68z"/>
    </svg>`;

  // Only write when the value changes. Writing identical text still counts as a DOM mutation,
  // which re-triggers the observers below and kept scheduleUpdate() running every frame.
  function setText(el, text) {
    if (el.textContent !== text) el.textContent = text;
  }

  function setAttr(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  function removeAttr(el, name) {
    if (el.hasAttribute(name)) el.removeAttribute(name);
  }

  function tryInsert() {
    const button = document.getElementById("dyn-checkout");
    if (!button) return false;
    if (!button.querySelector("svg")) {
      button.insertAdjacentHTML("afterbegin", svg);
    }

    let label = button.querySelector(".dyn-checkout-label");
    if (!label) {
      label = document.createElement("span");
      label.className = "dyn-checkout-label";
      label.textContent = "SECURE";
      const icon = button.querySelector("svg");
      if (icon) {
        icon.insertAdjacentElement("afterend", label);
      } else {
        button.appendChild(label);
      }
    } else {
      setText(label, "SECURE");
    }
    return true;
  }

  // --- Cart title (YOUR CART) count sync ---
  let subtotalObserver = null;

  function extractCartCount() {
    const subtotal = document.querySelector(".dyn-subtotal-items");
    if (!subtotal) return null;
    const text = subtotal.textContent || "";
    const match = text.match(/\d+/);
    return match ? parseInt(match[0], 10) : null;
  }

  function ensureHeaderLeftSpan() {
    let left = document.querySelector(".dyn-heading-text-left");
    if (left) return left;
    const title = document.querySelector(".dyn-cart-heading-title");
    if (!title) return null;
    left = document.createElement("span");
    left.className = "dyn-heading-text-left";
    title.prepend(left);
    return left;
  }

  function updateCartTitleCount() {
    const count = extractCartCount();
    const left = ensureHeaderLeftSpan();
    if (!left) return false;
    // Cache base title to avoid compounding parentheses
    if (!left.dataset.baseTitle) {
      const current = left.textContent || "";
      left.dataset.baseTitle = current.replace(/\s*\(\d+\)\s*$/, "").trim() || current.trim() || "YOUR CART";
    }
    setText(left, Number.isFinite(count) ? `${left.dataset.baseTitle} (${count})` : left.dataset.baseTitle);
    // Clear any right-side legacy count if present
    const right = document.querySelector(".dyn-heading-text-right");
    if (right) setText(right, "");
    return true;
  }

  function updateEmptyCartButton() {
    const emptyBtn = document.querySelector(".dyn-empty-cart-btn-action");
    if (emptyBtn && emptyBtn.textContent === "Shop Now") {
      emptyBtn.textContent = "Shop All Products";
    }
  }

  function updateEmptyCartSubtitle() {
    const subtitle = document.querySelector(".dyn-empty-cart-subtitle");
    if (subtitle) {
      setText(subtitle, "Smarter nicotine starts here.");
    }
  }

  function updateEmptyCartTitle() {
    const title = document.querySelector(".dyn-empty-cart-title");
    if (title) {
      setText(title, "Your cart is empty");
    }
  }

  function injectEmptyCartProducts() {
    const bodyWidget = document.querySelector(".dyn-empty-cart-body-widgets");
    if (!bodyWidget || bodyWidget.querySelector(".menu-drawer__navigation")) return false;

    const html = `
    <div class="mobile-menu">
      <nav class="menu-drawer__navigation">
        <div class="mm-body" style="padding: 0px 15px !important; background: #fff; overflow-y: unset;">
          <div class="mm-top">
            <a href="/products/breakers" class="mm-card">
              <img
                class="mm-thumb"
                src="https://cdn.shopify.com/s/files/1/0039/5093/6137/files/Breakers_4MG_ALL_FLAVORS_2dc9c879-340a-47fb-8702-02f94c5070f7.webp?v=1776971649"
                alt="The Breakers"
                loading="lazy"
                width="64"
                height="47"
              >
              <div>
                <div class="mm-title">THE BREAKERS</div>
                <p class="mm-desc">
                  Pouches with a burstable flavor capsule.
                </p>
              </div>
            </a>
            <a href="/products/pouches" class="mm-card">
              <img
                class="mm-thumb"
                src="https://cdn.shopify.com/s/files/1/0039/5093/6137/files/pouches-megamenu.webp"
                alt="The Pouches"
                loading="lazy"
                width="64"
                height="47"
              >
              <div>
                <div class="mm-title">THE POUCHES</div>
                <p class="mm-desc">
                  Discreet, tobacco-free pouches for long-lasting nicotine and flavor.
                </p>
              </div>
            </a>
            <a href="/products/gum" class="mm-card">
              <img
                class="mm-thumb"
                src="https://cdn.shopify.com/s/files/1/0039/5093/6137/files/gum-megamenu.webp"
                alt="The Gum"
                loading="lazy"
                width="64"
                height="47"
              >
              <div>
                <div class="mm-title">THE GUM</div>
                <p class="mm-desc">
                  Chewable nicotine for on-the-go satisfaction.
                </p>
              </div>
            </a>
          </div>
        </nav>
      </div>
    `;

    bodyWidget.insertAdjacentHTML("beforeend", html);
    return true;
  }

  function startSubtotalObserver() {
    if (subtotalObserver) return true;
    const subtotal = document.querySelector(".dyn-subtotal-items");
    if (!subtotal) return false;
    subtotalObserver = new MutationObserver(() => {
      // batch updates to avoid excessive recalculations while the cart updates
      scheduleUpdate();
    });
    subtotalObserver.observe(subtotal, { childList: true, subtree: true, characterData: true });
    // Initial sync after attaching
    updateCartTitleCount();
    return true;
  }

  let cartPreviouslyFocused = null;
  let cartFocusPending = false;
  let cartIsOpen = false;

  function getVisibleCartDrawer() {
    const drawer = document.querySelector(".dyn-main-cart-slide");
    return drawer && drawer.getClientRects().length ? drawer : null;
  }

  function restoreCartFocus() {
    if (!cartIsOpen) return;
    cartIsOpen = false;
    cartFocusPending = false;

    if (cartPreviouslyFocused instanceof HTMLElement && document.contains(cartPreviouslyFocused)) {
      cartPreviouslyFocused.focus();
    }
  }

  function handleCartDrawerKeydown(event) {
    const drawer = event.currentTarget;
    const nestedDialog = event.target.closest('[role="dialog"]');
    if (nestedDialog && nestedDialog !== drawer) return;

    if (event.key === "Escape") {
      const closeControl = drawer.querySelector(".dyn-cart-close-container, .cart-close");
      if (closeControl) {
        event.preventDefault();
        closeControl.click();
        setTimeout(restoreCartFocus, 0);
      }
      return;
    }

    if (event.key !== "Tab") return;

    const focusableElements = Array.from(
      drawer.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((element) => element.getClientRects().length);

    if (!focusableElements.length) {
      event.preventDefault();
      drawer.focus();
      return;
    }

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }

  function ensureCartAccessibility() {
    const drawer = getVisibleCartDrawer();
    if (!drawer) return false;

    const labels = document.getElementById("cart-status-message")?.dataset || {};
    const title = drawer.querySelector(".dyn-cart-heading-title");
    const closeControl = drawer.querySelector(".dyn-cart-close-container, .cart-close");

    setAttr(drawer, "role", "dialog");
    setAttr(drawer, "aria-modal", "true");
    setAttr(drawer, "tabindex", "-1");

    if (title) {
      if (!title.id) title.id = "dynamatic-cart-dialog-title";
      setAttr(drawer, "aria-labelledby", title.id);
      removeAttr(drawer, "aria-label");
    } else {
      setAttr(drawer, "aria-label", labels.cartLabel || "Shopping cart");
      removeAttr(drawer, "aria-labelledby");
    }

    if (drawer.dataset.a11yKeyboardBound !== "true") {
      drawer.addEventListener("keydown", handleCartDrawerKeydown);
      drawer.dataset.a11yKeyboardBound = "true";
    }

    if (closeControl) {
      setAttr(closeControl, "role", "button");
      setAttr(closeControl, "tabindex", "0");
      setAttr(closeControl, "aria-label", labels.closeLabel || "Close cart");

      if (closeControl.dataset.a11yKeyboardBound !== "true") {
        closeControl.addEventListener("keydown", (event) => {
          if (event.key !== "Enter" && event.key !== " ") return;
          event.preventDefault();
          closeControl.click();
        });
        closeControl.addEventListener("click", () => setTimeout(restoreCartFocus, 0));
        closeControl.dataset.a11yKeyboardBound = "true";
      }
    }

    if (cartFocusPending) {
      cartFocusPending = false;
      requestAnimationFrame(() => (closeControl || drawer).focus());
    }

    return true;
  }

  let rafId = 0;
  function scheduleUpdate() {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = 0;
      try {
        tryInsert();
        updateCartTitleCount();
        updateEmptyCartButton();
        updateEmptyCartSubtitle();
        updateEmptyCartTitle();
        injectEmptyCartProducts();
        ensureCartAccessibility();
      } catch (_) {
        /* no-op */
      }
    });
  }

  function waitAndInsert(timeoutMs = 10000) {
    // Attempt immediately (batched)
    scheduleUpdate();

    const observer = new MutationObserver(() => {
      scheduleUpdate();
      if (startSubtotalObserver()) observer.disconnect();
    });

    const scope = document.getElementById("dyn-cart-container") || document.body;
    observer.observe(scope, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), timeoutMs);
  }

  // Watch for empty cart section appearing (when items are removed)
  let emptyObserver = null;
  function observeEmptyCartSection() {
    if (emptyObserver) return; // Already observing

    emptyObserver = new MutationObserver(() => {
      const emptySection = document.getElementById("dyn-empty-cart-section");
      if (emptySection && emptySection.offsetParent !== null) {
        scheduleUpdate();
      } else {
        // Empty section not visible, check if cart has items
        const cartItems = document.querySelector(".dyn-cart-items-container");
        if (cartItems && cartItems.children.length > 0) {
          // Cart has items, disconnect to reduce overhead
          if (emptyObserver) {
            emptyObserver.disconnect();
            emptyObserver = null;
          }
        }
      }
    });

    const scope = document.getElementById("dyn-cart-container") || document.body;
    emptyObserver.observe(scope, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class"],
    });
  }

  window.addEventListener("dyn_cart_open", () => {
    cartPreviouslyFocused = document.activeElement;
    cartIsOpen = true;
    cartFocusPending = true;
    waitAndInsert();
    observeEmptyCartSection();
  });

  document.addEventListener(
    "click",
    (event) => {
      if (cartIsOpen && event.target.closest(".cart-overlay")) {
        setTimeout(restoreCartFocus, 0);
      }
    },
    true
  );

  // Listen for cart updates to restart observer if items removed
  window.addEventListener("cart:updated", observeEmptyCartSection);
  window.addEventListener("cart:change", observeEmptyCartSection);

  // Also run on load in case cart is already open
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeEmptyCartSection);
  } else {
    observeEmptyCartSection();
  }
})();
